/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function closeComparisonModal($modal) {
  $modal.addClass('is-closing');

  setTimeout(function () {

    $modal.removeClass('is-open is-closing is-visible');

    if (window.lenis) {
      window.lenis.start();
    }

  }, 300);
}

function setPopupImage(img, src) {
  if (!img || !src) return;
  if (img.src === src) return;

  img.style.transition = 'opacity 0.1s ease';
  img.style.opacity = '0';

  clearTimeout(img._fadeTimer);

  img._fadeTimer = setTimeout(function () {
    img.src = src;
    img.srcset = '';
    img.style.opacity = '1';
  }, 80);
}

function applyPopupVariant(input, cell) {
  if (!input) return;

  var src = $(input).data('image');
  var img = cell.querySelector('.comparison-table__image');

  if (src) setPopupImage(img, src);
}

function applyPopupType(typeInput, cell) {
  if (!typeInput) return;

  var typeName = $(typeInput).data('name');

  $(cell).find('.variant.color').hide();

  $(cell)
    .find('.variant.color[data-name="' + typeName + '"]')
    .show();

  var first = $(cell).find(
    '.variant.color[data-name="' + typeName + '"] .variant-input'
  )[0];

  if (first) {
    $(first).prop('checked', true);
    applyPopupVariant(first, cell);
  }
}

/* =========================
   LENIS SCROLL FIX
   Kai lenis.stop() aktyvus, Lenis preventDefault'ina wheel
   eventus prieš patikrindamas data-lenis-prevent (senesnėse
   versijose), todėl popup scroller užsirakina. Sustabdom
   eventų bubbling iš scroller'io, kad Lenis jų nematytų —
   natyvus scroll lieka veikti.
========================= */

function stopScrollPropagation(e) {
  e.stopPropagation();
}

function patchPopupScrollers() {
  $('.desk_comparison-product-popup__scroller').each(function () {
    if (this._lenisPatched) return;
    this._lenisPatched = true;

    this.addEventListener('wheel', stopScrollPropagation, { passive: true });
    this.addEventListener('touchmove', stopScrollPropagation, { passive: true });
  });
}

$(function () {
  patchPopupScrollers();
});

$(document).on('shopify:section:load', function () {
  patchPopupScrollers();
});

$(document).on('click', '.product-cards__compare-text', function () {

  var modalId = $(this).data('modal');

  if (window.lenis) {
    window.lenis.stop();
  }

  var $modal = $('#' + modalId);

  $modal.addClass('is-open');

  requestAnimationFrame(function () {

    $modal.addClass('is-visible');

    var dialog = $modal.find('.desk_comparison-product-popup__dialog')[0];

    if (dialog) dialog.focus();

  });

});

$(document).on(
  'click',
  '.desk_comparison-product-popup__scroller',
  function (e) {

    if (!$(e.target).closest('.desk_comparison-product-popup__dialog').length) {
      closeComparisonModal($(this).closest('.desk_comparison-product-popup'));
    }

  }
);

$(document).on(
  'click',
  '.desk_comparison-product-popup__close',
  function () {

    closeComparisonModal($(this).closest('.desk_comparison-product-popup'));

  }
);

$(document).on('keydown', function (e) {

  if (e.key !== 'Escape') return;

  var $open = $('.desk_comparison-product-popup.is-open');

  if ($open.length) {
    closeComparisonModal($open);
  }

});

$(document).on(
  'mouseenter',
  '.desk_comparison-product-popup .comparison-table__image-wrap',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var img = cell.querySelector('.comparison-table__image');

    var hoverSrc = img ? img.dataset.hoverSrc : null;

    if (!hoverSrc) return;

    var checked = cell.querySelector('.variant-input:checked');

    if (checked && checked.dataset.image) {
      setPopupImage(img, checked.dataset.image);
    } else if (img.dataset.variantSrc) {
      setPopupImage(img, img.dataset.variantSrc);
    }

  }
);

$(document).on(
  'mouseleave',
  '.desk_comparison-product-popup .comparison-table__image-wrap',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var img = cell.querySelector('.comparison-table__image');

    var hoverSrc = img ? img.dataset.hoverSrc : null;

    if (hoverSrc) {
      setPopupImage(img, hoverSrc);
    }

  }
);

$(document).on(
  'mouseenter',
  '.desk_comparison-product-popup .variant__label',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var input = document.getElementById($(this).attr('for'));

    applyPopupVariant(input, cell);

  }
);

$(document).on(
  'mouseleave',
  '.desk_comparison-product-popup .comparison-table__variants',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var img = cell.querySelector('.comparison-table__image');

    var hoverSrc = img ? img.dataset.hoverSrc : null;

    if (hoverSrc) {
      setPopupImage(img, hoverSrc);
    } else {
      var checked = cell.querySelector('.variant-input:checked');
      applyPopupVariant(checked, cell);
    }

  }
);

$(document).on(
  'click',
  '.desk_comparison-product-popup .variant__label',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var input = document.getElementById($(this).attr('for'));

    if (input) input.checked = true;

  }
);

$(document).on(
  'mouseenter',
  '.desk_comparison-product-popup .type__label',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var input = document.getElementById($(this).attr('for'));

    applyPopupType(input, cell);

  }
);

$(document).on(
  'click',
  '.desk_comparison-product-popup .type__label',
  function () {

    var cell = $(this).closest('.comparison-cell')[0];
    var input = document.getElementById($(this).attr('for'));

    if (input) input.checked = true;

    applyPopupType(input, cell);

  }
);


/* =========================
   SCROLL REVEAL (RESTORED)
========================= */

$(function () {

  if (typeof ScrollReveal === 'undefined') return;
  if (window.innerWidth <= 799) return;

  var sr = ScrollReveal();

  $('.product-cards').each(function () {

    var $section = $(this);

    var sectionClass = $section.attr('class').match(/product-cards-\S+/);

    if (!sectionClass) return;

    var selector = '.' + sectionClass[0];

    sr.reveal(selector + ' .product-cards__title', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal(selector + ' .product-cards__compare-text', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal(selector + ' .product-cards__grid > *', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      interval: 40,
      once: true
    });

  });

});